let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3RTYP")).then(() => parcelRequire('3ekdi'));